var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTip),expression:"showTip"}],staticClass:"wxtip"},[_c('van-icon',{staticClass:"wxtip-icon",attrs:{"name":"share","color":"#fff"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"wxtip-txt"},[_vm._v("点击右上角"),_c('br'),_vm._v("选择在浏览器中打开")])
}]

export { render, staticRenderFns }